<template>
  <div class="base-status-orders">
    <!-- 搜索和筛选区域 -->
    <div class="search-section">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="订单号">
          <el-input v-model="searchForm.orderNo" placeholder="请输入订单号" clearable></el-input>
        </el-form-item>
        <el-form-item label="客户名称">
          <el-input v-model="searchForm.customerName" placeholder="请输入客户名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="商家名称">
          <el-input v-model="searchForm.merchantName" placeholder="请输入商家名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="searchForm.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 订单列表 -->
    <el-table
      v-loading="loading"
      :data="orderList"
      border
      style="width: 100%">
      <el-table-column
        prop="orderSn"
        label="订单号"
        min-width="180">
      </el-table-column>
      <el-table-column
        prop="projectName"
        label="项目名称"
        min-width="150">
      </el-table-column>
      <el-table-column
        prop="customerName"
        label="客户名称"
        min-width="150">
      </el-table-column>
      <el-table-column
        prop="merchantName"
        label="商家名称"
        min-width="150">
      </el-table-column>
      <el-table-column
        prop="testCount"
        label="样品数量"
        width="100">
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        width="180">
      </el-table-column>
      <el-table-column
        prop="expectedEndTime"
        label="预期完成时间"
        width="180">
      </el-table-column>
      <el-table-column
        label="操作"
        width="150"
        fixed="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="handleViewDetail(scope.row)">
            查看详情
          </el-button>
          <slot name="actions" :row="scope.row"></slot>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import adminApi from '@/api/adminApi'

export default {
  name: 'BaseStatusOrders',
  props: {
    status: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      searchForm: {
        orderNo: '',
        customerName: '',
        merchantName: '',
        dateRange: []
      },
      orderList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  created() {
    this.fetchOrders()
  },
  methods: {
    // 获取订单列表
    async fetchOrders() {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          size: this.pageSize,
          status: this.status,
          ...this.getSearchParams()
        }
        
        const res = await adminApi.getOrderList(params)
        if (res) {
          this.orderList = res.list || []
          this.total = res.total || 0
        }
      } catch (error) {
        console.error('获取订单列表失败:', error)
        this.$message.error('获取订单列表失败')
      } finally {
        this.loading = false
      }
    },
    
    // 获取搜索参数
    getSearchParams() {
      const params = {}
      
      if (this.searchForm.orderNo) {
        params.orderNo = this.searchForm.orderNo
      }
      if (this.searchForm.customerName) {
        params.customerName = this.searchForm.customerName
      }
      if (this.searchForm.merchantName) {
        params.merchantName = this.searchForm.merchantName
      }
      if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
        params.startTime = this.searchForm.dateRange[0]
        params.endTime = this.searchForm.dateRange[1]
      }
      
      return params
    },
    
    // 处理搜索
    handleSearch() {
      this.currentPage = 1
      this.fetchOrders()
    },
    
    // 处理重置
    handleReset() {
      this.searchForm = {
        orderNo: '',
        customerName: '',
        merchantName: '',
        dateRange: []
      }
      this.handleSearch()
    },
    
    // 处理查看详情
    handleViewDetail(row) {
      this.$router.push(`/admin/orders/detail/${row.id}`)
    },
    
    // 处理每页条数变化
    handleSizeChange(val) {
      this.pageSize = val
      this.fetchOrders()
    },
    
    // 处理页码变化
    handleCurrentChange(val) {
      this.currentPage = val
      this.fetchOrders()
    },
    
    // 触发状态变更事件
    emitStatusChange() {
      this.$emit('status-change')
    }
  }
}
</script>

<style scoped>
.base-status-orders {
  padding: 20px;
}

.search-section {
  margin-bottom: 20px;
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.search-form {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

/* 确保日期选择器宽度合适 */
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 240px;
}
</style> 